import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideIn12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowSlideIn12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.411 9.78a3.76 3.76 0 0 1-1.996-.694l.613-.672a2.885 2.885 0 1 0-.248-4.646l-.67-.612a3.77 3.77 0 0 1 2.495-.94l.196.005a3.785 3.785 0 0 1 3.585 3.585L11.39 6a3.786 3.786 0 0 1-3.786 3.785zM4.445 7.607a.45.45 0 0 1-.636-.635l.512-.513H1.105a.451.451 0 0 1 0-.9h3.222L3.81 5.04a.451.451 0 0 1 .636-.637l1.602 1.602z"
            />
        </svg>
    );
}
export default memo(IconArrowSlideIn12);
